import React from "react";
import { useLanguage } from "../../i18n/LanguageContext";
import { images } from "../../i18n/translations";
import { SectionHeading } from "../ui/SectionHeading";
import { Reveal } from "../ui/Reveal";

// Fixed masonry via CSS columns for a natural, staggered layout.
export function Gallery() {
  const {
    t
  } = useLanguage();
  return <section id="galeria" className="w-full bg-slate-50 py-20 sm:py-28" data-id="element-152" data-mp="1o5k7jq2hiav1">
      <div className="max-w-content mx-auto px-4 sm:px-6" data-id="element-153" data-mp="1t1sier9nfhwe">
        <SectionHeading eyebrow={t.gallery.eyebrow} title={t.gallery.title} subtitle={t.gallery.subtitle} data-id="element-154" data-mp="1y15du0el5xal" />

        <Reveal className="mt-14" data-id="element-155" data-mp="223s0zo0bau1g">
          <div className="columns-1 sm:columns-2 lg:columns-3 gap-4 [column-fill:_balance]" data-id="element-156" data-mp="272cxbccg0tkm">
            {images.gallery.map((src, i) => <figure key={src + i} className="group relative mb-4 break-inside-avoid overflow-hidden rounded-sm shadow-sm" data-id="element-157" data-mp="7qag68rakba4" data-mpi={i}>
                <img src={src} alt={t.gallery.title + " " + (i + 1)} loading="lazy" className="w-full h-auto object-cover transition-transform duration-500 group-hover:scale-105" data-id="element-158" data-mp="3dr0il4tkisi9" />
                <div className="absolute inset-0 bg-navy-dark/0 transition-colors duration-300 group-hover:bg-navy-dark/25" data-id="element-159" data-mp="34vstfses8ccs" />
              </figure>)}
          </div>
        </Reveal>
      </div>
    </section>;
}